<script setup lang="ts">
import dayjs from 'dayjs'
import { useQuery, useQueryClient } from '@tanstack/vue-query'
import utc from 'dayjs/plugin/utc'
import zhCN from '@arco-design/web-vue/es/locale/lang/zh-cn'
import enUS from '@arco-design/web-vue/es/locale/lang/en-us'
import ptPT from '@arco-design/web-vue/es/locale/lang/pt-pt'

dayjs.extend(utc)

const { locale } = useI18n()
const localeObj = computed(() => {
  return {
    zh: zhCN,
    en: enUS,
    pt: ptPT,
  }[locale.value]
})

useHead({
  htmlAttrs: {
    lang: locale,
  },
})
const { $request } = useNuxtApp()
const user = useUser()
const queryClient = useQueryClient()
const [dataTimeliness, userInfo, regions] = await Promise.all([
  useRequest<Api.Dim.DataTimeliness>('/dim/info/dataTimeliness', { key: 'dataTimeliness' }),
  useRequest<Api.User.Info>('/user/info', { key: 'userInfo' }),
  useRequest<{ data: Api.User.Region[] }>('/user/regions', { key: 'regions' }),
])

if (dataTimeliness.data.value) {
  user.value.dataTimeliness = dataTimeliness.data.value
}
if (regions.data.value) {
  user.value.regions = regions.data.value.data || []
}

if (import.meta.client) {
  /** 刷新dataTimeliness接口 */
  useQuery({
    queryKey: ['/dim/info/dataTimeliness'],
    queryFn: async () => {
      const res = await $request<Api.Dim.DataTimeliness>('/dim/info/dataTimeliness')
      user.value.dataTimeliness = res
      return res
    },
    refetchOnWindowFocus: true,
  })
}

watch(userInfo.data, (data) => {
  user.value.info = data ?? {
    id: 0,
    name: 'v',
    phone: '13611111111',
    expireInSecond: 1704038400,
    isNewUser: 0,
    userRole: 0,
    permissions: [],
    privileges: [],
    accessToken: '',
  } as unknown as Api.User.Info
  user.value.isLogin = user.value.info.id > 0
}, { immediate: true })

watch(() => user.value.isLogin, () => {
  // 登录状态变化重新请求
  nextTick(() => {
    // 取消正在进行的 query
    queryClient.cancelQueries()
    queryClient.refetchQueries()
  })
})
</script>

<template>
  <a-config-provider :locale="localeObj" global>
    <NuxtLayout>
      <NuxtPage :keepalive="false" />
      <Login />
      <IdentityExpiredDialog />

      <OtherPtContact />
      <DialogBrOnline v-if="locale === 'zh'" />
    </NuxtLayout>
  </a-config-provider>
</template>
